
const Profile = () => {
  return (
    <div className='generalStyle'>
        <h1> Profile</h1>
        <p> The Profile page</p>
    </div>
  )
}

export default Profile